import Appointment from './Appointment'
import Auth from './Auth'
import DoctorProfile from './DoctorProfile'
import DoctorSchedules from './DoctorSchedules'

export default {
  appointment: Appointment,
  auth: Auth,
  doctorProfile: DoctorProfile,
  doctorSchedule: DoctorSchedules
}
